import { ProductTier } from '@sparemin/api-sdk';
import { connect } from 'react-redux';
import { State } from 'redux/types';
import { PropsOf } from 'types';
import { SubscriptionPeriod } from '../../../../types';
import { planCTALabelSelector } from '../../selectors';
import ProPlanCta, { ProPlanCtaProps as Props } from './ProPlanCta';

type StateProps = Pick<Props, 'children'>;

interface OwnProps {
  subscriptionPeriod: SubscriptionPeriod;
}

const mapStateToProps = (state: State, props: OwnProps): StateProps => ({
  children: planCTALabelSelector(state, { ...props, tier: ProductTier.PRO }),
});

const component = connect(mapStateToProps)(ProPlanCta);
export type ProPlanCtaProps = PropsOf<typeof component>;
export default component;
